module.exports = __webpack_public_path__ + "static/media/มะเมีย.2d28aea6.png";